import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Button,
  ListItem,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import theme from "../theme/Theme";

const useStyles = makeStyles(() => ({
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: 'flex-start',
    letterSpacing: 0,
    textTransform: 'none',
    width: '100%',
    height: 30,
  },
  icon: {
    width: 35,
    height: 35,
    marginRight: theme.spacing(1)
  },
  title: {
    color: theme.palette.text.primary,
    marginRight: 'auto'
  },
  active: {
    color: theme.palette.text.primary,
    '& $title': {
      fontWeight: theme.typography.fontWeightMedium
    },
    '& $icon': {
      color: theme.palette.text.primary
    }
  }
}));

const MyMenuItem = ({
  href,
  icon,
  title,
  selected,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <ListItem
      className={clsx(classes.item)}
      disableGutters
      {...rest}
    >

      <Button
        className={classes.button}
        component={RouterLink}
        to={href}
      >
        <div style={{
          visibility: selected ? "visible" : "hidden",
          color: theme.palette.primary.main,
          display: "flex",
          alignItems: "center",
        }}>▶</div>
          {/*{icon}*/}
        {icon && (
          <img
            className={classes.icon}
            src={icon}
          />
        )}
        <span className={classes.title}>
          {title}
        </span>
      </Button>
    </ListItem>
  );
};

MyMenuItem.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string
};

export default MyMenuItem;
